var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.orderAsideStep,
        ((_obj = {}), (_obj[_vm.$style.checked] = true), _obj),
        ((_obj$1 = {}),
        (_obj$1[_vm.$style.active] = _vm.isCurrentCategory),
        _obj$1)
      ]
    },
    [
      _c("div", { class: _vm.$style.selectedTitle }, [
        _c("h6", { class: _vm.titleStyle }, [
          _vm._v(_vm._s(_vm.currentCategory.name))
        ]),
        _vm._v(" "),
        _vm.itemsCounter &&
        _vm.categoryKey !== _vm.$options.burgerWrapCategoryId
          ? _c("span", { class: _vm.$style.selectedQuantity }, [
              _vm._v("\n      " + _vm._s(_vm.itemsCounter))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.isBundleCategory && _vm.itemSelectedInCategory(_vm.categoryKey)
        ? _c(
            "div",
            _vm._l(_vm.getSelectedItems(_vm.categoryKey), function(
              item,
              index
            ) {
              return _c(
                "span",
                { key: item.key, class: _vm.$style.orderAsideProducts },
                [
                  item.quantity > 1
                    ? _c("span", [
                        _vm._v(
                          "\n        " + _vm._s(item.quantity) + "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n      " + _vm._s(_vm.items[item.key].name) + "\n      "
                  ),
                  item.modifier
                    ? _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.modifierByKey(item.modifier).name) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  index !== _vm.getSelectedItems(_vm.categoryKey).length - 1
                    ? _c("span", [_vm._v(",\n      ")])
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm.isBundleCategory && _vm.bundleSelectedProductsList.length
        ? _c(
            "div",
            [
              _vm._l(_vm.bundleSelectedProductsList, function(product, index) {
                return _c("span", { key: index }, [
                  index > 0 ? _c("span", [_vm._v(" + ")]) : _vm._e(),
                  _vm._v("\n      " + _vm._s(product.name) + "\n    ")
                ])
              }),
              _vm._v(" "),
              _vm.bundleTotalPrice
                ? _c("span", [
                    _vm._v(
                      "\n      (" +
                        _vm._s(_vm._f("currency")(_vm.bundleTotalPrice)) +
                        ")\n    "
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _c("div", [
            _c("span", { class: _vm.$style.emptyCategory }, [_vm._v("—")])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorSelectedOptionsGroup.vue?vue&type=template&id=1f03a124&
// module id = null
// module chunks = 